/** ACT004 数据热点（type=9）运行时归一化（与控制台 act004-data-hotspot.js 口径一致） */

export const ACT004_DATA_HOTSPOT_FONT_OPTIONS = [
  { label: '系统默认', value: 'DEFAULT' },
  { label: '苹方', value: 'PINGFANG' },
  { label: '微软雅黑', value: 'MICROSOFT_YAHEI' },
  { label: 'Arial', value: 'ARIAL' },
  { label: 'Helvetica', value: 'HELVETICA' },
  { label: 'Impact 粗体', value: 'IMPACT' },
  { label: 'DIN1451 数字', value: 'DIN1451' }
]

export const ACT004_DATA_HOTSPOT_FONT_STACK = {
  DEFAULT: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif',
  PINGFANG: '"PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif',
  MICROSOFT_YAHEI: '"Microsoft YaHei", "PingFang SC", sans-serif',
  ARIAL: 'Arial, sans-serif',
  HELVETICA: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  IMPACT: 'Impact, "Arial Black", sans-serif',
  DIN1451: '"Act004DIN1451", "DIN", "D-DIN", "DIN Alternate", "Arial Narrow", Impact, sans-serif'
}

export const ACT004_LEADERBOARD_NAME_FIELD_OPTIONS = [
  { label: '姓名', value: 'name' },
  { label: '手机号', value: 'phone' },
  { label: '昵称', value: 'nickname' },
  { label: '员工号', value: 'employee_no' },
  { label: '公司名称', value: 'company_name' },
  { label: '渠道', value: 'channel' }
]

export const ACT004_DIN1451_FONT_URL =
  'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/font/DIN1451.ttf'
export const ACT004_DIN1451_FONT_FAMILY = 'Act004DIN1451'

let _din1451FontLoadPromise = null

export function normalizeAct004DataType(raw) {
  const v = String(raw || '').trim()
  if (v === 'CHECKIN_POINT_RANK') return 'CHECKIN_POINT_RANK'
  if (v === 'ACTIVITY_CHECKIN_LEADERBOARD') return 'ACTIVITY_CHECKIN_LEADERBOARD'
  if (v === 'ACTIVITY_USER_JOIN_TIME') return 'ACTIVITY_USER_JOIN_TIME'
  if (v === 'USER_LOTTERY_CHANCE') return 'USER_LOTTERY_CHANCE'
  return 'USER_ACTIVITY_POINTS'
}

export function isAct004LeaderboardDataType(dataType) {
  return normalizeAct004DataType(dataType) === 'ACTIVITY_CHECKIN_LEADERBOARD'
}

export function act004DataHotspotSupportsTextAffix(dataType) {
  const t = normalizeAct004DataType(dataType)
  return t === 'USER_ACTIVITY_POINTS' || t === 'ACTIVITY_USER_JOIN_TIME' || t === 'USER_LOTTERY_CHANCE'
}

export function normalizeAct004DataTextPrefix(raw) {
  return raw == null ? '' : String(raw).trim()
}

export function normalizeAct004DataTextSuffix(raw) {
  return raw == null ? '' : String(raw).trim()
}

export function normalizeAct004DataBindPointIndex(raw, dataType) {
  if (normalizeAct004DataType(dataType) !== 'CHECKIN_POINT_RANK') return null
  const n = parseInt(raw, 10)
  return Number.isFinite(n) && n > 0 ? n : null
}

export function normalizeAct004LeaderboardTopN(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? Math.max(1, Math.min(100, n)) : 10
}

export function normalizeAct004LeaderboardFlag(raw, defaultOn = 1) {
  if (raw == null || raw === '') return defaultOn ? 1 : 0
  return raw === 1 || raw === true || raw === '1' ? 1 : 0
}

export function normalizeAct004LeaderboardNameField(raw) {
  const v = String(raw || '').trim().toLowerCase()
  if (v === 'real_name') return 'name'
  const allowed = ACT004_LEADERBOARD_NAME_FIELD_OPTIONS.map((o) => o.value)
  return allowed.includes(v) ? v : 'name'
}

export function normalizeAct004LeaderboardPadding(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? Math.max(0, Math.min(200, n)) : 0
}

export function normalizeAct004DataFontSize(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? Math.max(12, n) : 30
}

/** 排行榜单列字号：显式配置优先；未配置时回退 dataFontSize */
export function normalizeAct004LeaderboardColFontSize(raw, fallbackDataFontSize) {
  if (raw == null || raw === '') {
    return normalizeAct004DataFontSize(fallbackDataFontSize)
  }
  return normalizeAct004DataFontSize(raw)
}

export function normalizeAct004DataFontFamily(raw) {
  const v = String(raw || '').trim().toUpperCase()
  if (v === 'RANXI_DIN') return 'DIN1451'
  const allowed = ACT004_DATA_HOTSPOT_FONT_OPTIONS.map((o) => o.value)
  if (allowed.includes(v)) return v
  return 'DEFAULT'
}

export function normalizeAct004DataFontBold(raw) {
  if (raw == null || raw === '') return 1
  return raw === 1 || raw === true || raw === '1' ? 1 : 0
}

export function normalizeAct004DataFontColor(raw) {
  const s = String(raw == null ? '' : raw).trim()
  if (!s) return '#000000'

  const hex6Match = s.match(/^#?([0-9a-fA-F]{6})$/)
  if (hex6Match) return `#${hex6Match[1]}`.toUpperCase()

  const hex3Match = s.match(/^#?([0-9a-fA-F]{3})$/)
  if (hex3Match) {
    const h = hex3Match[1]
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toUpperCase()
  }

  const rgbMatch = s.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i)
  if (rgbMatch) {
    const toHex = (n) => {
      const v = Math.max(0, Math.min(255, Math.round(parseFloat(n))))
      return v.toString(16).padStart(2, '0')
    }
    return `#${toHex(rgbMatch[1])}${toHex(rgbMatch[2])}${toHex(rgbMatch[3])}`.toUpperCase()
  }

  return '#000000'
}

export function resolveAct004DataHotspotFontFamilyCss(raw) {
  const key = normalizeAct004DataFontFamily(raw)
  return ACT004_DATA_HOTSPOT_FONT_STACK[key] || ACT004_DATA_HOTSPOT_FONT_STACK.DEFAULT
}

/** 预加载活动页数字字体 DIN1451（与小程序 App.vue 一致） */
export function ensureAct004Din1451FontLoaded() {
  if (typeof document === 'undefined') return Promise.resolve()
  try {
    if (document.fonts && document.fonts.check(`16px "${ACT004_DIN1451_FONT_FAMILY}"`)) {
      return Promise.resolve()
    }
  } catch (e) {
    /* ignore */
  }
  if (_din1451FontLoadPromise) return _din1451FontLoadPromise
  _din1451FontLoadPromise = new Promise((resolve) => {
    if (typeof FontFace === 'undefined') {
      resolve()
      return
    }
    const font = new FontFace(ACT004_DIN1451_FONT_FAMILY, `url(${ACT004_DIN1451_FONT_URL})`)
    font.load()
      .then((loaded) => {
        document.fonts.add(loaded)
        resolve()
      })
      .catch(() => resolve())
  })
  return _din1451FontLoadPromise
}

export function pickAct004LeaderboardFields(src) {
  const h = src && typeof src === 'object' ? src : {}
  const fallbackFs = normalizeAct004DataFontSize(h.dataFontSize)
  return {
    leaderboardTopN: normalizeAct004LeaderboardTopN(h.leaderboardTopN),
    leaderboardShowRank: normalizeAct004LeaderboardFlag(h.leaderboardShowRank, 1),
    leaderboardRankPrefix: normalizeAct004DataTextPrefix(h.leaderboardRankPrefix),
    leaderboardRankSuffix: normalizeAct004DataTextSuffix(h.leaderboardRankSuffix),
    leaderboardRankPaddingLeft: normalizeAct004LeaderboardPadding(h.leaderboardRankPaddingLeft),
    leaderboardRankPaddingRight: normalizeAct004LeaderboardPadding(h.leaderboardRankPaddingRight),
    leaderboardRankFontSize: normalizeAct004LeaderboardColFontSize(h.leaderboardRankFontSize, fallbackFs),
    leaderboardShowName: normalizeAct004LeaderboardFlag(h.leaderboardShowName, 1),
    leaderboardNameField: normalizeAct004LeaderboardNameField(h.leaderboardNameField),
    leaderboardNamePrefix: normalizeAct004DataTextPrefix(h.leaderboardNamePrefix),
    leaderboardNameSuffix: normalizeAct004DataTextSuffix(h.leaderboardNameSuffix),
    leaderboardNamePaddingLeft: normalizeAct004LeaderboardPadding(h.leaderboardNamePaddingLeft),
    leaderboardNamePaddingRight: normalizeAct004LeaderboardPadding(h.leaderboardNamePaddingRight),
    leaderboardNameFontSize: normalizeAct004LeaderboardColFontSize(h.leaderboardNameFontSize, fallbackFs),
    leaderboardShowCheckinCount: normalizeAct004LeaderboardFlag(h.leaderboardShowCheckinCount, 1),
    leaderboardCheckinPrefix: normalizeAct004DataTextPrefix(h.leaderboardCheckinPrefix),
    leaderboardCheckinSuffix: normalizeAct004DataTextSuffix(h.leaderboardCheckinSuffix),
    leaderboardCheckinPaddingLeft: normalizeAct004LeaderboardPadding(h.leaderboardCheckinPaddingLeft),
    leaderboardCheckinPaddingRight: normalizeAct004LeaderboardPadding(h.leaderboardCheckinPaddingRight),
    leaderboardCheckinFontSize: normalizeAct004LeaderboardColFontSize(h.leaderboardCheckinFontSize, fallbackFs)
  }
}

export function emptyAct004LeaderboardFields(fallbackDataFontSize) {
  return pickAct004LeaderboardFields({ dataFontSize: fallbackDataFontSize })
}

/** 排行榜行高按可见列中最大字号计算 */
export function resolveAct004LeaderboardRowFontSize(hotspot) {
  const h = hotspot && typeof hotspot === 'object' ? hotspot : {}
  const fallbackFs = normalizeAct004DataFontSize(h.dataFontSize)
  const sizes = []
  if (normalizeAct004LeaderboardFlag(h.leaderboardShowRank, 1) === 1) {
    sizes.push(normalizeAct004LeaderboardColFontSize(h.leaderboardRankFontSize, fallbackFs))
  }
  if (normalizeAct004LeaderboardFlag(h.leaderboardShowName, 1) === 1) {
    sizes.push(normalizeAct004LeaderboardColFontSize(h.leaderboardNameFontSize, fallbackFs))
  }
  if (normalizeAct004LeaderboardFlag(h.leaderboardShowCheckinCount, 1) === 1) {
    sizes.push(normalizeAct004LeaderboardColFontSize(h.leaderboardCheckinFontSize, fallbackFs))
  }
  if (!sizes.length) return fallbackFs
  return Math.max.apply(null, sizes)
}

export function pickAct004DataHotspotFields(h) {
  const src = h && typeof h === 'object' ? h : {}
  const dataType = normalizeAct004DataType(src.dataType)
  const affixOn = act004DataHotspotSupportsTextAffix(dataType)
  const base = {
    dataType,
    dataBindPointIndex: normalizeAct004DataBindPointIndex(src.dataBindPointIndex, dataType),
    dataTextPrefix: affixOn ? normalizeAct004DataTextPrefix(src.dataTextPrefix) : '',
    dataTextSuffix: affixOn ? normalizeAct004DataTextSuffix(src.dataTextSuffix) : '',
    dataFontSize: normalizeAct004DataFontSize(src.dataFontSize),
    dataFontFamily: normalizeAct004DataFontFamily(src.dataFontFamily),
    dataFontBold: normalizeAct004DataFontBold(src.dataFontBold),
    dataFontColor: normalizeAct004DataFontColor(src.dataFontColor)
  }
  if (isAct004LeaderboardDataType(dataType)) {
    return { ...base, ...pickAct004LeaderboardFields(src) }
  }
  return base
}

/** 从 profile / 行数据解析展示名称 */
export function resolveAct004LeaderboardDisplayName(row, nameField) {
  const field = normalizeAct004LeaderboardNameField(nameField)
  const profile = row && row.profile && typeof row.profile === 'object' ? row.profile : null
  if (profile) {
    const fromProfile = profile[field]
    if (fromProfile != null && String(fromProfile).trim()) return String(fromProfile).trim()
    if (field === 'name' && profile.real_name != null && String(profile.real_name).trim()) {
      return String(profile.real_name).trim()
    }
  }
  if (row && row.name != null && String(row.name).trim() && (field === 'name' || !profile)) {
    return String(row.name).trim()
  }
  return ''
}

export function formatAct004LeaderboardAffixText(prefix, value, suffix) {
  return `${normalizeAct004DataTextPrefix(prefix)}${value == null ? '' : String(value)}${normalizeAct004DataTextSuffix(suffix)}`
}

export function collectAct004DataHotspotFontFamilyKeysFromPages(pages) {
  const set = new Set()
  const walk = (list) => {
    if (!Array.isArray(list)) return
    list.forEach((h) => {
      if (!h || String(h.type) !== '9') return
      set.add(normalizeAct004DataFontFamily(h.dataFontFamily))
    })
  }
  if (Array.isArray(pages)) {
    pages.forEach((p) => walk(p && p.hotspots))
  }
  return Array.from(set)
}

export function preloadAct004DataHotspotFontsForPages(pages) {
  const keys = collectAct004DataHotspotFontFamilyKeysFromPages(pages)
  if (keys.includes('DIN1451')) {
    return ensureAct004Din1451FontLoaded()
  }
  return Promise.resolve()
}
